module.exports = __webpack_public_path__ + "static/media/6.047b3675.jpg";